module.exports = __webpack_public_path__ + "media/images/founders/founder_0-c55049db8a72a010c29e8fef2f7d43e4.jpg";